var $document = $(document);

// TODO :| - form.js duplicates a lot of the logic in this file. Let's have one way, same way!

// for remote: true methods
$document.on('ajax:before', 'form.validate', function (e) {
  var $form = $(this);
  var valid = true;

  $form.find('input.mandatory, textarea.mandatory').each(function () {
    var $input = $(this);
    if ($input.is(':visible') && $input.val().trim().length == 0) {
      valid = false;
    }
  });
  return valid;
});

$document.on('submit', 'form.validate', function (event) {
  var $form = $(this);
  if (!checkIsFormValid($form)) {
    $form.addClass('invalid');
    event.preventDefault();
  } else {
    $form.removeClass('invalid');
  }
});

$document.on('change', '.mandatory--radio', function (event) {
  var $radio = $(this);
  if ($radio.is(':checked')) {
    $radio.closest('.form__field').removeClass('form__field--invalid');
  }
});

function isVisible($input) {
  var visible = $input.is(':visible');

  // Handle some special cases where the input is replaced (such as select2)
  if (!visible) {
    if ($input.hasClass('dynamic-selector__selector')) {
      visible = $input.closest('.dynamic-selector').is(':visible');
    }
  }
  return visible;
}

//Use this for non-ajax forms. To be refactored along with form.js
function checkIsFormValid($form) {
  var valid = true;

  // For use when input requirements are satified by one of multiple input fields
  valid = checkGroupValid($form);

  $form.find(':input.mandatory').each(function () {
    if (valid) {
      var $input = $(this);

      if (isVisible($input) && $input.val().trim().length == 0) {
        $input
          .closest('.form__field')
          .find('.form__field-error')
          .addClass('-show');
        if ($input.hasClass('dynamic-selector__selector')) {
          $input.select2('open');
        } else {
          $input.focus();
        }
        valid = false;
      } else {
        $input.parent().find('.form__field-error').removeClass('-show');
      }
    }
  });

  // For radio buttons - add the class and remove on selection of an option
  $form.find('.form__field--invalid').each(function () {
    if (valid == false) return;

    var $input = $(this).find('input');

    if ($input.is(':visible')) {
      $input.focus();
      valid = false;
    }
  });

  return valid;
}

function checkGroupValid($form) {
  var valid = true;
  $form.find('.mandatory__group').each(function () {
    var $inputGroup = $(this);
    var $groupValid = false;
    $inputGroup.find('.group__member').each(function () {
      var $input = $(this);
      if (
        $input.is(':visible') &&
        $input.val().trim().length > 0 &&
        $groupValid
      ) {
        $groupValid = false;
      } else if ($input.is(':visible') && $input.val().trim().length > 0) {
        $groupValid = true;
      }
    });
    if (!$groupValid) {
      $inputGroup
        .closest('.form__field')
        .find('.form__field-error')
        .addClass('-show');
      valid = false;
    } else {
      $inputGroup
        .closest('.form__field')
        .find('.form__field-error')
        .removeClass('-show');
    }
  });
  return valid;
}

$document.on('change', 'input.validate--integer', function () {
  $(this).val($(this).val().replace(/\D/g, ''));
});

$document.on('keydown', 'input.validate--integer', function (e) {
  var code = e.keyCode;
  // backspace, and up, down, left, right arrows
  var valid_codes = [8, 37, 38, 39, 40];
  if (e.metaKey || valid_codes.indexOf(code) > -1) {
    return true;
  }

  return !e.shiftKey && /[0-9]/.test(e.key);
});

/* *** OLD IMPLEMENTATION BELOW THIS LINE - TO BE DECOMMISSIONED / REFACTORED OVER TIME **** */

jQuery.fn.validateFormOnSubmit = function () {
  $(this).each(function () {
    var $form = $(this);

    $form.submit(function (e) {
      if (!$form.hasClass('submit-attempted')) {
        // Add listeners...
        $form.find('fieldset').each(function () {
          var $fieldset = $(this);
          $(this)
            .find('.mandatory, input')
            .change(function () {
              $fieldset.validateFieldset();
            })
            .keyup(function () {
              $fieldset.validateFieldset();
            });
        });
        $form.addClass('submit-attempted');
      }
      var isValid = validateDeprecatedForm($form);
      $form.toggleClass('error', !isValid);
      return isValid;
    });
  });
};

/* TODO - I've updated this function name to validateDeprecatedForm as we have a new
 * validateForm in the new BEM implementation. We need to refactor this method out of use!
 */
function validateDeprecatedForm($form) {
  var isValid = true;
  var firstInvalid = null;
  $form.find('fieldset').each(function () {
    if (!$(this).validateFieldset()) {
      if (isValid) {
        firstInvalid = $(this);
        isValid = false;
      }
    }
  });
  if (!isValid) {
    firstInvalid
      .find(
        '.mandatory, input.email, input.date, input.ui-autocomplete-input'
      )[0]
      .focus();
  }
  return isValid;
}

jQuery.fn.validateFieldset = function () {
  var fieldset = $(this);
  var isValid = true;

  fieldset.find('.mandatory').each(function () {
    if ($(this).is(':visible') && !validateMandatory($(this))) {
      isValid = false;
    }
  });

  fieldset.find('input.email').each(function () {
    if ($(this).is(':visible') && !validateEmailInput($(this))) {
      isValid = false;
    }
  });

  fieldset.find('input.date').each(function () {
    if ($(this).is(':visible') && !validateDateInput($(this))) {
      isValid = false;
    }
  });

  fieldset
    .find('input.ui-autocomplete-input.autocomplete-invalid')
    .each(function () {
      if ($(this).is(':visible')) {
        isValid = false;
      }
    });

  fieldset.toggleClass('error', !isValid);

  return isValid;
};

function validateEmailInput($email_input) {
  var email_regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  var val = $email_input.val();
  var invalid_email = val.length > 0 && val.match(email_regex) == null;
  $email_input.toggleClass('invalid-email', invalid_email);
  $email_input
    .closest('.value')
    .toggleClass('invalid-email-error-msg', invalid_email);

  return !invalid_email;
}

function validateDateInput($date_input) {
  var date_string = $date_input.val();
  var parsed_date = parseDate(date_string, 'DMY');
  var is_valid = parsed_date != null && parsed_date != false;
  var adjustment = $date_input.attr('data-min-date');

  if (is_valid && adjustment != undefined) {
    var today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    var earliest_valid_date = new Date(
      today.getTime() + 24 * 60 * 60 * 1000 * adjustment
    );
    earliest_valid_date.setHours(0);
    earliest_valid_date.setMinutes(0);
    earliest_valid_date.setSeconds(0);
    earliest_valid_date.setMilliseconds(0);
    is_valid = parsed_date >= earliest_valid_date;
  }

  var invalid_date = date_string.length > 0 && !is_valid;
  $date_input.toggleClass('invalid-date', invalid_date);
  $date_input
    .closest('.value')
    .toggleClass('invalid-date-error-msg', invalid_date);

  return !invalid_date;
}

function validateMandatory($mandatory_input) {
  var invalid_mandatory = $mandatory_input.val() == 0;
  $mandatory_input.toggleClass('invalid-mandatory', invalid_mandatory);
  $mandatory_input
    .closest('.value')
    .toggleClass('invalid-mandatory-error-msg', invalid_mandatory);

  return !invalid_mandatory;
}

function isValidDate(dateStr, format) {
  var parsed_date = parseDate(dateStr, format);
  return parsed_date != null && parsed_date != false;
}

function parseDate(dateStr, format, timeStr) {
  dateStr = dateStr
    .replace('Jan', '01')
    .replace('Feb', '02')
    .replace('Mar', '03')
    .replace('Apr', '04')
    .replace('May', '05')
    .replace('Jun', '06')
    .replace('Jul', '07')
    .replace('Aug', '08')
    .replace('Sep', '09')
    .replace('Oct', '10')
    .replace('Nov', '11')
    .replace('Dec', '12')
    .replace('January', '01')
    .replace('February', '02')
    .replace('March', '03')
    .replace('April', '04')
    .replace('June', '06')
    .replace('July', '07')
    .replace('August', '08')
    .replace('September', '09')
    .replace('October', '10')
    .replace('November', '11')
    .replace('December', '12');

  if (dateStr == '') return true;
  if (format == null) {
    format = 'DMY';
  }
  format = format.toUpperCase();
  if (format.length != 3) {
    format = 'DMY';
  }
  if (
    format.indexOf('M') == -1 ||
    format.indexOf('D') == -1 ||
    format.indexOf('Y') == -1
  ) {
    format = 'DMY';
  }
  if (format.substring(0, 1) == 'Y') {
    // If the year is first
    var reg1 = /^\d{2}(\s|-|\/|\.)\d{1,2}\1\d{1,2}$/; // white space, -, |, /,
    var reg2 = /^\d{4}(\s|-|\/|\.)\d{1,2}\1\d{1,2}$/;
  } else if (format.substring(1, 2) == 'Y') {
    // If the year is second
    var reg1 = /^\d{1,2}(\s|-|\/|\.)\d{2}\1\d{1,2}$/;
    var reg2 = /^\d{1,2}(\s|-|\/|\.)\d{4}\1\d{1,2}$/;
  } else {
    // The year must be third
    var reg1 = /^\d{1,2}(\s|-|\/|\.)\d{1,2}\1\d{2}$/;
    var reg2 = /^\d{1,2}(\s|-|\/|\.)\d{1,2}\1\d{4}$/;
  }
  // If it doesn't conform to the right format (with either a 2 digit year or 4 digit year), fail
  if (reg1.test(dateStr) == false && reg2.test(dateStr) == false) {
    return false;
  }
  var parts = dateStr.split(RegExp.$1); // Split into 3 parts based on what the divider was
  // Check to see if the 3 parts end up making a valid date
  if (format.substring(0, 1) == 'M') {
    var mm = parts[0];
  } else if (format.substring(1, 2) == 'M') {
    var mm = parts[1];
  } else {
    var mm = parts[2];
  }
  if (format.substring(0, 1) == 'D') {
    var dd = parts[0];
  } else if (format.substring(1, 2) == 'D') {
    var dd = parts[1];
  } else {
    var dd = parts[2];
  }
  if (format.substring(0, 1) == 'Y') {
    var yy = parts[0];
  } else if (format.substring(1, 2) == 'Y') {
    var yy = parts[1];
  } else {
    var yy = parts[2];
  }
  if (parseFloat(yy) <= 50) {
    yy = (parseFloat(yy) + 2000).toString();
  }
  if (parseFloat(yy) <= 99) {
    yy = (parseFloat(yy) + 1900).toString();
  }

  if (timeStr == undefined || timeStr == null) {
    var hour = 0;
    var min = 0;
  } else {
    var hours_minutes = timeStr.match(/[0-9]+/g);

    hour = parseFloat(hours_minutes[0]);
    if (hour == 12) {
      hour = 0;
    }
    if (
      timeStr[timeStr.length - 2] == 'p' ||
      timeStr[timeStr.length - 2] == 'P'
    ) {
      hour += 12;
    }
    min = parseFloat(hours_minutes[1]);
  }

  var dt = new Date(
    parseFloat(yy),
    parseFloat(mm) - 1,
    parseFloat(dd),
    hour,
    min,
    0,
    0
  );
  if (parseFloat(dd) != dt.getDate()) {
    return null;
  }
  if (parseFloat(mm) - 1 != dt.getMonth()) {
    return null;
  }
  return dt;
}

module.exports = {
  checkIsFormValid: checkIsFormValid,
  parseDate: parseDate,
};
